import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { DateObject } from "react-multi-date-picker";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@mui/material";

//import utils
import { convertToGregorian } from "../../../../utils/date.js";
import { LocaleContext } from "../../../../routing/LangRouter.js";

//import customized hooks
import useDateChange from "../../../../hooks/useDateChange.js";

//import general components
import SingleDatePicker from "../../../common/single-date-picker/single-date-picker";
import BaseTextField from "../../../common/base-text-field/base-text-field.jsx";
import { BaseButton } from "../../../common/base-button/base-button.jsx";

//import images and icons
import { SearchNormal } from "iconsax-react";

function TourSearchForm({ handleFormChange, filterList }) {
    //general variables
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    //initial form values
    const initialFormState = {
        searchValue: "",
        date: "",
    };

    //initialize form with react-hook-form
    const { register, handleSubmit, setValue, getValues, control } = useForm({
        defaultValues: initialFormState,
    });

    //handle date changes for tour search
    const { startDate, defaultValueDate, handleDateFormatChange } = useDateChange(null, null, false);
    const [endDate, setEndDate] = useState();
    const handleDateChange = dates => {
        const isPersianCalendar = locale === "fa" ? true : false;
        handleDateFormatChange([dates], isPersianCalendar);

        // Create an end date object for the last day of the selected month
        const endDateObject = new DateObject(dates).add(1, "month").subtract(1, "day");
        if (isPersianCalendar) {
            const convertedEndDate = convertToGregorian(endDateObject);
            setEndDate(convertedEndDate?.toISOString().split("T")[0]);
        } else {
            setEndDate(endDateObject?.format("YYYY-MM-DD"));
        }
    };
    useEffect(() => {
        if ((startDate, endDate)) {
            setValue("date", { startDate, endDate });
        }
    }, [startDate, endDate]);

    //handle form submission with registration data
    const handleRegistration = data => {
        handleFormChange(data);
    };

    return (
        <Container maxWidth="xl">
            <Grid
                className="tour__tour-search-form"
                component="form"
                container
                item
                xs={12}
                rowGap={3}
                columnGap={1}
                alignItems="stretch"
                mb={{ xs: 0, md: 5 }}
                onSubmit={handleSubmit(handleRegistration)}
            >
                <Grid container item xs={12} md={3}>
                    <BaseTextField
                        label={`${t("searchBy")} ${t("city")} / ${t("country")} / ${t("tourName")}`}
                        radius="10px"
                        name="searchValue"
                        register={{ ...register("searchValue") }}
                        focused={!!getValues("searchValue")}
                    />
                </Grid>

                <Grid container item xs={12} md={3}>
                    <SingleDatePicker
                        label={t("tourStartTime")}
                        name="date"
                        size="medium"
                        handleChange={handleDateChange}
                        defaultValue={defaultValueDate}
                        minDate={new Date()}
                        onlyMonth={true}
                        control={control}
                        format="MMMM YYYY"
                        isPersianCalendar={locale === "fa"}
                    />
                </Grid>

                <Grid container item xs={12} md={1}>
                    <BaseButton
                        text={`${t("search")}`}
                        color="primary-10"
                        size="large"
                        radius="radius-20"
                        type="submit"
                        leftIcon={<SearchNormal size="24" color="var(--primary-color)" />}
                    />
                </Grid>

                <Grid container item xs={12} rowGap={1} columnGap={1}>
                    {filterList?.keywords?.map(keyword => {
                        return (
                            <Grid
                                className={`tour__keyword ${keyword?.id && "aactive"}`}
                                key={keyword?.id}
                                container
                                item
                                xs="auto"
                                alignItems="center"
                                onClick={() => {
                                    handleFormChange({ searchValue: keyword?.keyword, date: { startDate, endDate } });
                                    setValue("searchValue", keyword?.keyword);
                                }}
                            >
                                {keyword?.keyword}
                            </Grid>
                        );
                    })}
                </Grid>
            </Grid>
        </Container>
    );
}

export default TourSearchForm;
